import { useToastContext } from '../contexts/ToastContext.jsx';

const useToast = () => {
  return useToastContext();
};

export default useToast;
